{ "id": "contre", "name": "Contre", "icon": "icons/spells/contre", "description": "Bouclier qui absorbe 40 dégâts pendant 3 s.", "cooldown": 10, "effects": [ { "type": "shield", "amount": 40, "duration": 3 } ] }
